<template>
  <div style="min-height: 100vh; position: relative">
    <div
      v-if="!selectedBot.status"
      style="position: absolute; z-index: 2; background-color: #ecececbd;top: 0; left: 0; right: 0; bottom: 0 "
    >
      <div class="text-xs-center mt-5 pt-5" style="margin-bottom: 25px;">
        <v-card max-width="600" style="margin: auto">
          <v-card-text>
            <h2 style="text-shadow: 1px 1px 20px #9e9e9e;" class="display-1">
              {{ $t('If you want to test, please activate your bot') }}
            </h2>
            <p>
              {{ $t('Information will not be recorded in analytics if the bot is inactivated') }}
            </p>

            <v-btn
              depressed
              style="margin-bottom:1.5em"
              @click="toggleBotStatus"
              small
              color="primary"
              >{{ $t('Click for starting your Bot') }}</v-btn
            >
          </v-card-text>
        </v-card>
      </div>
    </div>
    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12 sm8>
          <v-btn
            depressed
            :outline="filter != 'all'"
            :color="filter == 'all' ? 'primary' : 'grey'"
            @click="
              filter = 'all'
              getIntent()
            "
            class="ma-0 mr-1 mb-1"
            >{{ $t('All') }}</v-btn
          >
          <v-btn
            depressed
            :outline="filter != 'facebook'"
            :color="filter == 'facebook' ? 'primary' : 'grey'"
            @click="
              filter = 'facebook'
              getIntent()
            "
            class="ma-0 mr-1 mb-1"
          >
            <i class="fab fa-facebook-square mr-1"></i>
            {{ $t('Facebook') }}
          </v-btn>
          <v-btn
            depressed
            :outline="filter != 'line'"
            :color="filter == 'line' ? 'primary' : 'grey'"
            @click="
              filter = 'line'
              getIntent()
            "
            class="ma-0 mr-1 mb-1"
          >
            <i class="fab fa-line mr-1"></i>
            {{ $t('Line') }}
          </v-btn>
          <v-btn
              depressed
              :outline="filter != 'instagram'"
              :color="filter== 'instagram' ? 'primary' : 'grey'"
              @click="
                filter = 'instagram'
                getIntent()
              "
              class="ma-0 mr-1 mb-1"
            >
              <i class="fab fa-instagram mr-1"></i>
              {{ $t('Instagram') }}</v-btn
            >
            <v-btn
              depressed
              :outline="filter!= 'google'"
              :color="filter == 'google' ? 'primary' : 'grey'"
              @click="
                filter = 'google'
                getIntent()
              "
              class="ma-0 mr-1 mb-1"
            >
              <i class="fab fa-google mr-1"></i>
              {{ $t('Google') }}</v-btn
            >
        </v-flex>
        <v-flex xs12 sm4 class="text-sm-right">
          <template v-if="selectedBot.pageid == '109179590915799'">
            <v-btn
              v-if="$store.getters.getPackage != 'premium'"
              outline
              color="grey"
              class="ma-0 mb-1"
            >
              <i class="fas fa-file-export mr-1"></i>
              {{ $t('export') }} Thai Union
              <v-premium-lock></v-premium-lock>
            </v-btn>
            <v-btn
              v-else
              @click="getchatlogthaiunionformat"
              color="primary"
              outline
              class="ma-0 mb-1"
              :loading="loadingThaiUnion"
            >
              <i class="fas fa-file-export mr-1"></i>
              {{ $t('export') }} Thai Union
            </v-btn>
          </template>
          <template v-if="loading">
            <v-btn :loading="true" color="grey" outline class="ma-0 mb-1"></v-btn>
          </template>
          <template v-else>
            <v-btn
              v-if="$store.getters.getPackage != 'premium' || isCoachlab"
              outline
              color="grey"
              class="ma-0 mb-1"
            >
              <i class="fas fa-file-export mr-1"></i>
              {{ $t('export') }}
              <v-premium-lock></v-premium-lock>
            </v-btn>
            <v-btn
              v-else-if="$store.getters.getPackage == 'premium'"
              @click="exportDashboard"
              color="grey"
              outline
              class="ma-0 mb-1"
            >
              <i class="fas fa-file-export mr-1"></i>
              {{ $t('export') }}
            </v-btn>
          </template>
        </v-flex>
      </v-layout>

      <date-filter v-model="selectedDate" @onSelected="getIntent"></date-filter>

      <h1 class="mt-2">{{ $t('Conversation') }}</h1>
      <v-layout wrap>
        <v-flex xs12 sm12 md12>
          <div class="pa-1">
            <v-card>
              <v-card-title>
                <v-layout>
                  <v-flex>{{ $t('Conversation') }}</v-flex>
                  <v-flex class="text-xs-right">
                    <!-- <v-btn small outline color="primary">{{$t('Export')}}</v-btn> -->
                  </v-flex>
                </v-layout>
              </v-card-title>

              <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>

              <div style="max-width: 350px; margin: auto">
                <apexchart
                  ref="intent"
                  type="pie"
                  :options="intent"
                  :series="intentSeries"
                  style="margin: auto"
                ></apexchart>
              </div>
              <v-divider></v-divider>
              <v-data-table
                v-bind:pagination.sync="pagination"
                :headers="intentHeaders"
                :items="intentChartData"
                :rows-per-page-items="[10, 25, 45, { text: $t('All'), value: -1 }]"
                :rows-per-page-text="$t('Rows per page')"
              >
                <template v-slot:items="props">
                  <td>
                    <v-avatar :color="props.item.color" size="15"></v-avatar>
                  </td>
                  <td>
                    <template v-if="props.item.name == '{default}'">{{
                      $t('Default Conversation')
                    }}</template>
                    <template v-else-if="props.item.name == null">{{ $t('Other') }}</template>
                    <template v-else-if="props.item.name == '{welcome}'">{{
                      $t('Welcome Message')
                    }}</template>
                    <template v-else>{{ props.item.name }}</template>
                  </td>
                  <td>{{ props.item.value | numberFormat }}</td>
                  <td>
                    <v-btn
                      fab
                      icon
                      small
                      flat
                      color="grey"
                      @click="openIntentDetail(props.item.name)"
                    >
                      <v-icon>search</v-icon>
                    </v-btn>
                  </td>
                </template>

                <template slot="no-data">
                  <div class="text-xs-center">{{ $t('No conversation') }}</div>
                </template>
              </v-data-table>
            </v-card>
          </div>
        </v-flex>
        <!-- <v-flex xs12 sm12 md6>
          <div class="pa-1">
            <v-card>
              <v-card-title>
                <v-layout>
                  <v-flex>{{ $t('Comment') }}</v-flex>
                  <v-flex class="text-xs-right">
                    <!-- <v-btn small outline color="primary">{{$t('Export')}}</v-btn> ->
                  </v-flex>
                </v-layout>
              </v-card-title>

              <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>

              <div style="max-width: 350px; margin: auto">
                <apexchart
                  ref="comment"
                  type="pie"
                  :options="comment"
                  :series="commentSeries"
                  style="margin: auto"
                ></apexchart>
              </div>
              <v-divider></v-divider>
              <v-data-table
                v-bind:pagination.sync="commentPagination"
                :headers="commentHeaders"
                :items="commentChartData"
                :rows-per-page-items="[10, 25, 45, { text: $t('All'), value: -1 }]"
                :rows-per-page-text="$t('Rows per page')"
                item-key="name"
              >
                <template v-slot:items="props">
                  <td>
                    <v-avatar :color="props.item.color" size="15"></v-avatar>
                  </td>
                  <td>
                    <template v-if="props.item.name == '{default}'">{{
                      $t('Default Conversation')
                    }}</template>
                    <template v-else-if="props.item.name == null">{{ $t('Other') }}</template>
                    <template v-else-if="props.item.name == '{welcome}'">{{
                      $t('Welcome Message')
                    }}</template>
                    <template v-else-if="props.item.name == '{default_comment_to_inbox}'">{{
                      $t('More Comment to Inbox')
                    }}</template>
                    <template v-else>{{ props.item.name }}</template>
                  </td>
                  <td>{{ props.item.value | numberFormat }}</td>
                  <td>
                    <v-btn
                      fab
                      icon
                      small
                      flat
                      color="grey"
                      @click="openIntentDetail(props.item.name)"
                    >
                      <v-icon>search</v-icon>
                    </v-btn>
                  </td>
                </template>

                <template slot="no-data">
                  <div class="text-xs-center">{{ $t('No conversation') }}</div>
                </template>
              </v-data-table>
            </v-card>
          </div>
        </v-flex> -->
      </v-layout>

      <v-dialog v-model="showIntent" v-if="currentIntent" scrollable>
        <v-card>
          <v-card-title>
            <template v-if="currentIntent == '{default}'">{{
              $t('Default Conversation')
            }}</template>
            <template v-else-if="currentIntent == null">{{ $t('Other') }}</template>
            <template v-else-if="currentIntent == '{welcome}'">{{
              $t('Welcome Message')
            }}</template>
            <template v-else-if="currentIntent == '{default_comment_to_inbox}'">{{
              $t('More Comment to Inbox')
            }}</template>
            <template v-else>{{ currentIntent }}</template>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 300px" class="pa-0">
            <div v-if="loadingIntent">
              <div style="padding: 30px 0">
                <div class="spinner text-xs-center">
                  <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
                </div>
              </div>
            </div>
            <div v-else-if="filterIntentDetail.length <= 0">
              <div class="text-xs-center" style="margin: 35px 0">
                <img src="/static/img/assets/setting/conversation.png" alt style="width: 230px" />
                <h2>{{ $t('Not found any chatlog') }}</h2>
                <!-- <p>test</p> -->
              </div>
            </div>
            <div v-else>
              <template v-if="intentDetails && intentDetails.length">
                <v-data-table :headers="modalIntentHeader" :items="intentDetails" hide-actions>
                  <template v-slot:items="props">
                    <!-- <td>{{ props.item.name }}</td> -->
                    <td style="word-break: break-word">
                      {{ props.item.questiondata ? props.item.questiondata : $t('Other') }}
                    </td>
                    <td class="text-xs-center">{{ props.item.count | numberFormat }}</td>
                  </template>
                </v-data-table>

                <div class="text-xs-center mt-5 mb-3" v-if="$store.getters.getPackage != 'premium'">
                  <h2 style="text-shadow: 1px 1px 20px #9e9e9e">
                    {{ $t('Its time to upgrade.') }}
                  </h2>
                  <p style="text-shadow: 1px 1px 20px #9e9e9e">
                    {{
                      $t('Upgrade Your Plan to use {package} features , only {price} THB/month', {
                        price: packages.premium.price,
                        package: $t('PREMIUM')
                      })
                    }}
                  </p>
                  <v-btn
                    depressed
                    color="primary"
                    :to="'/' + $i18n.locale() + '/upgrade'"
                    v-if="selectedBot.pagetype != 'enterprise'"
                    >{{ $t('Upgrade to {package} Plan', { package: $t('PREMIUM') }) }}</v-btn
                  >
                </div>
              </template>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outline color="grey" @click="showIntent = false">{{ $t('cancel') }}</v-btn>
            <v-btn
              depressed
              color="primary"
              :to="trainingUrl"
              v-if="currentIntent == '{default}'"
              >{{ $t('Training') }}</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import DateFilter from './DateFilter'
import { mapGetters } from 'vuex'
import api from '@/api'

import dayjs from 'dayjs'
import numeral from 'numeral'
import XLSX from 'xlsx'

import VueApexCharts from 'vue-apexcharts'

import DashboardGraphLoading from './DashboardGraphLoading'

export default {
  data: function() {
    return {
      packages: this.getPackageDetail(),
      loading: true,
      loadingThaiUnion: false,
      loadingIntent: true,
      showIntent: false,
      filter: 'all',
      selectedDate: {
        start: dayjs()
          .subtract(7, 'days')
          .format('YYYY-MM-DD'),
        end: dayjs().format('YYYY-MM-DD')
      },
      currentIntent: undefined,
      currentIntentIndex: undefined,
      intentDetails: [],
      intentChartData: [],
      intentChart: undefined,
      modalIntentHeader: [
        { text: this.$t('customer says'), value: 'questiondata' },
        { text: this.$t('Count'), value: 'count', align: 'center' }
      ],
      intentHeaders: [
        { text: '', value: '', sortable: false },
        { text: this.$t('Conversation'), value: 'name' },
        { text: this.$t('Count'), value: 'value' },
        { text: '', value: 'view', sortable: false }
      ],
      commentHeaders: [
        { text: '', value: '', sortable: false },
        { text: this.$t('Conversation'), value: 'name' },
        { text: this.$t('Count'), value: 'value' },
        { text: '', value: 'view', sortable: false }
      ],
      pagination: { sortBy: 'value', descending: true, rowsPerPage: 10 },
      commentPagination: { sortBy: 'value', descending: true, rowsPerPage: 10 },
      commentChartData: [],

      intentSeries: [],
      commentSeries: [],

      intent: {
        chart: {
          type: 'donut',
          height: 350
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                // width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ],
        dataLabels: {
          enabled: true
        },
        legend: {
          show: false
        }
      },
      comment: {
        chart: {
          type: 'donut',
          height: 350
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                // width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ],
        dataLabels: {
          enabled: true
        },
        legend: {
          show: false
        }
      }
    }
  },
  components: {
    DashboardGraphLoading,
    apexchart: VueApexCharts,
    DateFilter
  },
  mounted: function() {
    if (this.selectedBot.status) this.getIntent()
    else {
      this.loadingIntent = false
      this.loading = false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
      isCoachlab: 'isCoachlab'
    }),

    filterIntentDetail: function() {
      var vm = this
      return vm.intentDetails.sort(function(a, b) {
        if (a.training == true && b.training != true) {
          return 1
        }
        if (a.training != true && b.training == true) {
          return -1
        }

        return 0
      })
    },
    trainingUrl: function() {
      return (
        '/' +
        this.currentLang +
        '/training?datefrom=' +
        dayjs(this.selectedDate.start).format('YYYY-MM-DD') +
        '&dateto=' +
        dayjs(this.selectedDate.end).format('YYYY-MM-DD')
      )
    }
  },
  methods: {
    getchatlogthaiunionformat() {
      var vm = this
      //thai union
      this.loadingThaiUnion = true
      api.getchatlogthaiunionformat(
        {
          pageid: this.selectedBot.pageid,
          datefrom: dayjs(this.selectedDate.start).format('YYYY-MM-DD'),
          dateto: dayjs(this.selectedDate.end).format('YYYY-MM-DD')
        },
        function(error, response) {
          if (error) {
            console.error(error)
            vm.loadingThaiUnion = false
            return
          }
          // console.log(response)
          if (response.responsecode == 200) {
            var json = []
            json = response.data.flatMap(el => {
              if (el.answerby == 'admin') {
                return [
                  {
                    Sender: el.answerby,
                    'facebook - line Name': el.facebookname,
                    empcode: el.empcode,
                    'User MessageType': el.messagetype,
                    'User Message': el.messagedata,
                    timestampDate: dayjs(el.timestamp).format('DD/MM/YYYY'),
                    timestampTime: dayjs(el.timestamp).format('HH:mm')
                  }
                ]
              } else {
                return [
                  {
                    Sender: 'customer',
                    'facebook - line Name': el.facebookname,
                    empcode: el.empcode,
                    'User MessageType': el.questiontype,
                    'User Message': el.questiondata,
                    timestampDate: dayjs(el.timestamp).format('DD/MM/YYYY'),
                    timestampTime: dayjs(el.timestamp).format('HH:mm')
                  },
                  {
                    Sender: el.answerby,
                    'facebook - line Name': 'Thai Union HR People Connect',
                    empcode: '',
                    'User MessageType': el.messagetype,
                    'User Message': el.messagedata,
                    timestampDate: dayjs(el.timestamp).format('DD/MM/YYYY'),
                    timestampTime: dayjs(el.timestamp).format('HH:mm')
                  }
                ]
              }
            })

            const dataWS = XLSX.utils.json_to_sheet(json)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, dataWS)
            XLSX.writeFile(wb, 'zwizdata-thaiunion-conversation.xlsx')
          }
          vm.loadingThaiUnion = false
        }
      )
    },
    getIntent: function() {
      let vm = this
      let data = {
        pageid: this.selectedBot.pageid,
        datefrom: dayjs(this.selectedDate.start).format('YYYY-MM-DD'),
        dateto: dayjs(this.selectedDate.end).format('YYYY-MM-DD'),
        app: this.filter
      }
      vm.loading = true
      api.getDashboardIntent(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.loading = false
          return
        }
        if (response.data) {
          let sortedData = response.data.sort(vm.sortIntent)
          let conversations = {
            data: [],
            label: [],
            color: [],
            intentname: [],
            intents: []
          }
          let comments = {
            data: [],
            label: [],
            color: [],
            intentname: [],
            intents: []
          }
          let data = []
          let label = []
          let color = []
          let intentname = []

          let intents = []
          // console.log(sortedData)
          $.each(sortedData, function(index, val) {
            if (val['messagetype'] == 'inbox') {
              if (val['intent'] === '{default}') {
                let intent = {}
                intent.name = val['intent']
                conversations.intentname.unshift(val['intent'])
                conversations.label.unshift(vm.$t('Default Conversation'))
                conversations.data.unshift(parseInt(val['count']))
                let current_color = vm.getRandomColor()
                conversations.color.unshift(current_color)

                intent.color = current_color
                intent.value = parseInt(val['count'])

                conversations.intents.unshift(intent)
              } else {
                let intent = {}
                if (val['intent'] == null) {
                  conversations.label.push(vm.$t('Other'))
                  // intent.name = vm.$t('Other')
                } else if (val['intent'] === '{welcome}') {
                  conversations.label.push(vm.$t('Welcome Message'))
                  // intent.name = vm.$t('Welcome Message')
                } else if (val['intent'] === '{default_comment_to_inbox}') {
                  conversations.label.push(vm.$t('More Comment to Inbox'))
                  // intent.name = vm.$t('More Comment to Inbox')
                } else {
                  conversations.label.push(val['intent'])
                }
                intent.name = val['intent']
                conversations.intentname.push(val['intent'])
                conversations.data.push(parseInt(val['count']))
                let current_color = vm.getRandomColor()
                conversations.color.push(current_color)

                intent.color = current_color
                intent.value = parseInt(val['count'])

                conversations.intents.push(intent)
              }
            } else {
              if (val['intent'] === '{default}') {
                let intent = {}
                intent.name = val['intent']
                comments.intentname.unshift(val['intent'])
                comments.label.unshift(vm.$t('Default Conversation'))
                comments.data.unshift(parseInt(val['count']))
                let current_color = vm.getRandomColor()
                comments.color.unshift(current_color)

                intent.color = current_color
                intent.value = parseInt(val['count'])

                comments.intents.unshift(intent)
              } else {
                let intent = {}
                if (val['intent'] == null) {
                  comments.label.push(vm.$t('Other'))
                  // intent.name = vm.$t('Other')
                } else if (val['intent'] === '{welcome}') {
                  comments.label.push(vm.$t('Welcome Message'))
                  // intent.name = vm.$t('Welcome Message')
                } else if (val['intent'] === '{default_comment_to_inbox}') {
                  comments.label.push(vm.$t('More Comment to Inbox'))
                  // intent.name = vm.$t('More Comment to Inbox')
                } else {
                  comments.label.push(val['intent'])
                }
                intent.name = val['intent']
                comments.intentname.push(val['intent'])
                comments.data.push(parseInt(val['count']))
                let current_color = vm.getRandomColor()
                comments.color.push(current_color)

                intent.color = current_color
                intent.value = parseInt(val['count'])

                comments.intents.push(intent)
              }
            }
          })
          vm.intentSeries = conversations.data
          vm.intent.labels = conversations.label
          vm.intent.intentname = conversations.intentname
          vm.intent.colors = conversations.color

          vm.intentChartData = conversations.intents

          vm.commentSeries = comments.data
          vm.comment.labels = comments.label
          vm.comment.intentname = comments.intentname
          vm.comment.colors = comments.color

          vm.commentChartData = comments.intents

          vm.$nextTick(function() {
            if (vm.$refs.intent) {
              vm.$refs.intent.updateOptions({
                colors: conversations.color,
                labels: conversations.label
              })
            }
            if (vm.$refs.comment) {
              vm.$refs.comment.updateOptions({
                colors: comments.color,
                labels: comments.label
              })
            }
            vm.loading = false
          })
        }
      })
    },
    getRandomColor: function() {
      var letters = '0123456789ABCDEF'
      var color = '#'
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
    truncate: function(text, limit) {
      let length = text.length
      return text.substring(0, Math.min(limit, length)) + (length > limit ? '...' : '')
    },
    sortIntent: function(a, b) {
      // console.log(a.count)
      if (parseInt(a.count) < parseInt(b.count)) return 1
      if (parseInt(a.count) > parseInt(b.count)) return -1
      return 0
    },
    getTrainingConversation: function() {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        intent: vm.currentIntent,
        type: 'inbox',
        datefrom: dayjs(this.selectedDate.start).format('YYYY-MM-DD'),
        dateto: dayjs(this.selectedDate.end).format('YYYY-MM-DD'),
        app: this.filter
      }
      vm.loadingIntent = true
      api.getGroupDefaultChatlogs(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.loadingIntent = false
          return
        }

        var intentDetail = []
        var current = null
        var count = 0
        if (response.data) {
          vm.intentDetails = response.data
        }
        vm.loadingIntent = false
      })
    },
    openIntentDetail: function(intentName) {
      var vm = this
      vm.currentIntent = intentName
      vm.loadingIntent = true
      vm.getTrainingConversation()
      vm.showIntent = true
    },
    exportDashboard: function() {
      let vm = this

      let csvContent = ''
      if (vm.loading) {
        return false
      }
      this.loading = true
      let json = []
      json.push([
        `${this.$t('from')} ` +
          dayjs(vm.selectedDate.start).format('DD/MM/YYYY') +
          ` ${this.$t('to')} ` +
          dayjs(vm.selectedDate.end).format('DD/MM/YYYY')
      ])

      json.push([])
      json.push([this.$t('Conversation')])
      json.push(['Name', 'Count', 'Percent'])

      var totalIntentMessage = 0
      vm.intent.labels.forEach(function(seriesData, index) {
        totalIntentMessage += vm.intentSeries[index]
      })

      vm.intent.labels.forEach(function(seriesData, index) {
        json.push([
          seriesData,
          numeral(vm.intentSeries[index]).format('0,0'),
          (totalIntentMessage > 0
            ? numeral((vm.intentSeries[index] * 100) / totalIntentMessage).format('0.0')
            : 0) + ' %'
        ])
      })
      json.push([])
      json.push([])
      json.push([this.$t('Reply to inbox')])
      json.push(['Name', 'Count', 'Percent'])

      var totalCommentMessage = 0
      vm.comment.labels.forEach(function(seriesData, index) {
        totalCommentMessage += vm.commentSeries[index]
      })

      vm.comment.labels.forEach(function(seriesData, index) {
        json.push([
          seriesData,
          numeral(vm.commentSeries[index]).format('0,0'),
          (totalCommentMessage > 0
            ? numeral((vm.commentSeries[index] * 100) / totalCommentMessage).format('0.0')
            : 0) + ' %'
        ])
      })

      const dataWS = XLSX.utils.aoa_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'zwizdata-summary-conversation.xlsx')
      this.loading = false
    },
    toggleBotStatus: async function() {
      let bot = Object.assign({}, this.selectedBot)
      bot.status = !bot.status
      this.$store.dispatch('loading')
      await this.$store.dispatch('toggleBotStatus', bot)
      this.$store.dispatch('loading')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/SummaryIntent.vue